
import {defineComponent, PropType, ref} from 'vue';
import {TopMenuItem} from './types';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';
import DropdownMenu from '@ohrm/oxd/core/components/DropdownMenu/DropdownMenu.vue';
import usei18n from '../../../composables/usei18n';

export default defineComponent({
  name: 'oxd-navigation-more',
  props: {
    menuItems: {
      type: Object as PropType<TopMenuItem[]>,
    },
  },
  components: {
    'oxd-icon': Icon,
    'oxd-dropdown-menu': DropdownMenu,
  },
  setup() {
    const expandedIndex = ref(-1);
    const onClickMenu = (
      $event: MouseEvent,
      item: TopMenuItem,
      index: number,
    ) => {
      if (!item.children || item.children.length === 0) {
        window.location.replace(item.url);
      } else {
        $event.preventDefault();
        $event.stopPropagation();
        expandedIndex.value = expandedIndex.value === index ? -1 : index;
      }
    };

    const onClose = () => {
      expandedIndex.value = -1;
    };

    return {
      onClose,
      onClickMenu,
      expandedIndex,
      ...usei18n(),
    };
  },
});
